// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffportal/v1/simulation_service.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import { SimulationService } from "./simulation_service_pb";

/**
 * @generated from rpc bffportal.v1.SimulationService.SimulateOrders
 */
export const simulateOrders = SimulationService.method.simulateOrders;

/**
 * @generated from rpc bffportal.v1.SimulationService.ListFloatingIndices
 */
export const listFloatingIndices = SimulationService.method.listFloatingIndices;
